import { FC, useContext, useEffect, useMemo, useRef } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useSearchParams } from 'react-router-dom'
import { useModal } from '../../../../../components'
import { getEmpresaClienteById } from '../../empresasCliente-list/core/_request'
import { ClienteView } from '../../empresasCliente-list/core/_models'

const QueryResponseContext = createResponseContext<ClienteView>(initialQueryResponse)

/**
 * Coordenadores não têm listagem paginada: vêm dentro do empregador (`cliente.colaboradores`).
 * Mesma chave do useClienteAtual, então o <ClienteHeading> e a tabela dividem a requisição.
 */
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const [searchParams] = useSearchParams()
  const cliente = Number(searchParams.get('cliente'))

  const {
    isFetching,
    isError,
    refetch,
    data: responseSemPaginacao,
  } = useQuery(['empresa-cliente', cliente], () => getEmpresaClienteById(cliente), {
    refetchOnWindowFocus: false,
    enabled: Boolean(cliente),
  })

  // Recarrega ao fechar o modal de cadastro/edição (o modal só chama closeModal).
  const modalJaAbriu = useRef(false)
  useEffect(() => {
    if (isOpen) {
      modalJaAbriu.current = true
    } else if (modalJaAbriu.current) {
      refetch()
    }
  }, [isOpen, refetch])

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, responseSemPaginacao, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
